"use client";

import React from "react";
import { ArrowRight, Quote } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TrustedByTravellers() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2,
    once: true
  });
  return <section id="trustedbytravellers" data-nav="light" className="bg-background text-foreground py-12 lg:py-18 border-y border-border/40 transition-colors">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <div ref={ref} className={`transition-all duration-700 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"} flex flex-col items-center`}>
          <div className="inline-flex items-center justify-center size-12 rounded-full bg-primary/10 text-primary mb-6">
            <Quote className="size-5 rotate-180" aria-hidden="true" />
          </div>

          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-normal tracking-tight text-foreground mb-3">
            Trusted by Travellers
          </h2>

          <p className="text-lg sm:text-xl font-bold text-foreground/90 tracking-wide mb-6">
            Real journeys. Real experiences.
          </p>

          <blockquote className="max-w-2xl mx-auto text-muted-foreground text-base sm:text-lg leading-relaxed italic mb-8 border-none p-0">
            &ldquo;Read experiences from travellers who have planned their holidays with Innoleaf.&rdquo;
          </blockquote>

          <div>
            <Button asChild size="lg" className="rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 shadow-sm transition-all duration-300">
              <Link to="#" className="inline-flex items-center gap-2 group">
                <span>Read Innoleaf Reviews</span>
                <ArrowRight className="size-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}